// src/config/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB-DZXRfjzYovLR20o4TexTpKR5d2_mPxU",
  authDomain: "cus-wl0.firebaseapp.com",
  projectId: "cus-wl0",
  storageBucket: "cus-wl0.firebasestorage.app",
  messagingSenderId: "655246350758",
  appId: "1:655246350758:web:9eaf383e4d7f924e609767",
  measurementId: "G-QCCPK2MWJ5",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
// googleProvider.setCustomParameters({
//   client_id: '66686595865-uqkup2rok47dmn9h8jmmu0a4cth6hq83.apps.googleusercontent.com'
// });
export const appleProvider = new OAuthProvider("apple.com");
export default app;
